import React from 'react';

import websitePage from '../../hoc/websitePage/websitePage';
import { getAllCategories, getAllQuestions, getHomepagePopularQuestions } from '../../service/cms/getFAQHomepageContent';
import FAQPage from '../../screens/FAQ/FAQ';
import FAQHeader from '../../components/HeaderCTA/FAQHeader';

export async function getStaticProps() {
  const questions = await getHomepagePopularQuestions();
  const categories = await getAllCategories();
  const allQuestions = await getAllQuestions();

  return {
    props: {
      cmsMessages: {
        questions,
        categories,
        allQuestions,
      },
    },
  };
}

export default websitePage(FAQPage, {
  routeKey: 'FAQ',
  customHeaderCTA: <FAQHeader buttonLabel="CREDIT_CARD.HERO.LABEL" />,
});

